import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import {currencyFormat} from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faEye, faFilter, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        Btn: 0,
        datosCargados: false,
        arrayResultado: [],
        ListaHistorial:[],Permisos:[],
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Material?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("materiales/borrar/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarArrayResultado(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    ListarArrayResultado(page) {
        Swal.showLoading();
        let btipo = document.getElementById('btipo').value;
        let bname = document.getElementById('bnombre').value;
        let muni = document.getElementById('mun').value;
        let global = document.getElementById('global').value;
   
        var datos = {tipo:btipo, nombre:bname,municipio:muni,globla:global};
        authAxios.post("materiales/index_new?page=" + page, datos)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', arrayResultado: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
                Swal.close();
            })
            .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    VerHistorial(id) {
        Swal.showLoading();
     
        authAxios.get("materiales/historial/" +id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ ListaHistorial: datosRespuesta.data.lista});
                Swal.close();
            })
            .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    ConsultarPermiso() {
        let user = localStorage.getItem('idusuario');
        let url = 'MasterMateriales';

        authAxios.get("roles/PermisoModulo/" + user + "/" + url + "")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ Permisos: datosRespuesta.data.data });
             
            })
            .catch(console.log);
    }
    porcentaje() {
        let user = localStorage.getItem('nombre');
        let categoria = document.getElementById('categoria').value;
        let porcentaje = document.getElementById('porcentaje').value;
        if(categoria==''){
            Swal.fire('Materiales!', 'Debes de seleccionar la categoria', 'warning');
            return false;
        }
        if(porcentaje==''){
            Swal.fire('Materiales!', 'Debes de digitar el porcentaje', 'warning');
            return false;
        }
        var datos = {usuario:user, categoria:categoria, porcentaje:porcentaje}
        this.setState({ Btn: 1});
        authAxios.post("materiales/porcentajes" , datos)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ Btn: 0});
                Swal.fire('Materiales!', datosRespuesta.data.msj, 'success');
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ConsultarPermiso();
        this.ListarArrayResultado(1);
        
    }
    render() {
        const { load, arrayResultado, pagina, ultimo, actual,ListaHistorial,Permisos, Btn } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">  
                        {
                            Permisos.registrar == 1 ?
                                <Link className="btn btn-success btn-sm" to={"/AddMateriales"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Material</Link>
                            :
                                ''
                        }
                            &nbsp;&nbsp;
                            <button id="por" name="por" className="btn btn-primary btn-sm"  data-bs-toggle='modal'
                                    data-bs-target="#ModalActualizacion" ><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Actualizacion Masiva de Porcentajes</button>

                        </div>
                        <div className="card-body">
                            <h4>Lista Materiales</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-3">
                                <select  className="form-select form-select-sm" name="btipo" id="btipo">
                                    <option value="MAT" selected>Material (MAT)</option>
                                    <option value="MO">Mano Obra (MO)</option>
                                    <option value="EQP">Equipo (EQP)</option>
                                    <option value="TRA">Transporte (TRA)</option>
                                </select>
                                </div>
                                <div className="col-xl-3">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="Material" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="mun" name="mun" placeholder="Municipio" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                <select  className="form-select form-select-sm" name="global" id="global">
                                    <option value="0">Material Global</option>
                                    <option value="1">Material Historico</option>
                                </select>
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                               
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                        <th className="align-middle">COD</th>
                                        <th className="align-middle">TIPO</th>
                                        <th className="align-middle">IVA</th>
                                            <th className="align-middle">UTILIDAD</th>
                                            <th className="align-middle">COD. SIESA</th>
                                            <th className="align-middle">MATERIAL</th>
                                            <th className="align-middle">UNIDAD</th>
                                            
                                            <th className="align-middle">VALOR COMPRA</th>
                                            <th className="align-middle">VALOR UNITARIO</th>
                                            
                                            <th className="align-middle">MUNICIPIO</th>
            
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            arrayResultado.map((itemArrayResultado) => (
                                                <tr key={itemArrayResultado.ID_TABLA}>
                                                    <td>{itemArrayResultado.CODIGO}</td>
                                                    <td>{itemArrayResultado.TIPO}</td>
                                                    <td>{itemArrayResultado.IVA} %</td>
                                                    <td>{itemArrayResultado.UTILIDAD} %</td>
                                                    <td>{itemArrayResultado.COD_SIESA}</td>
                                                    <td>{itemArrayResultado.NOMBRE}</td>
                                                    {
                                                        (() => {
                                                            switch (itemArrayResultado.ID_TIPO_UNIDAD) {
                                                                case 1:
                                                                    return (<td>GLB</td>)
                                                                case 2:
                                                                    return (<td>M</td>)
                                                                case 3:
                                                                    return (<td>ROLLO</td>)
                                                                case 4:
                                                                    return (<td>UND</td>)
                                                            }
                                                        })()
                                                    }
                                                     <td><b>$ </b>{currencyFormat(itemArrayResultado.VALOR_COMPRA)}</td>
                                                    <td><b>$ </b>{currencyFormat(itemArrayResultado.VALOR_UNITARIO)}</td>
                                                   
                                                    <td>{itemArrayResultado.MUNICIPIOREL}</td>
                                             
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                        {Permisos.registrar==1?
                                                            <Link
                                                                className="btn btn-primary btn-sm"
                                                                to={"/UpMateriales/" + itemArrayResultado.ID_TABLA}
                                                            >
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </Link>:''} &nbsp;&nbsp;
                                                            
                                                            <button
                                                                                            type="button"
                                                                                            className="btn btn-info btn-sm"
                                                                                            data-bs-toggle='modal'
                                                                                            data-bs-target="#ProductoModal"  style={{color: '#FFFFFF'}}
                                                                                            onClick={() =>
                                                                                                this.VerHistorial(itemArrayResultado.ID_TABLA)
                                                                                            }
                                                                                        > <FontAwesomeIcon icon={faEye} /></button> 
                                                                                         {Permisos.eliminar==1?
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() =>
                                                                    this.borrarRegistros(itemArrayResultado.ID_TABLA)
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </button>:''}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="ProductoModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ProductoModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="ProductoModalLabel"> HISTORIAL DE PRECIOS</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card">
                                 
                                    <div className="card-body">
                                        <div className='row'>
                                            <table className="table table-hover table-condensed table-sm">
                                                <thead className="thead-inverse">
                                                    <tr>
                                                        <th className="align-middle">ID</th>
                                                        <th className="align-middle">PRECIO</th>
                                                        <th className="align-middle">FECHA ACTUALIZACION</th>
                                                        <th className="align-middle">USUARIO</th>
                                               
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {load}
                                                    {
                                                        ListaHistorial.map((item) => (
                                                       
                                                            <tr key={item.ID}>
                                                                <td>{item.ID}</td>
                                                                <td style={{textAlign: "right"}}>${currencyFormat(item.PRECIO_VENTA)}</td>
                                                                <td>{item.FECHA_REG}</td>
                                                                <td>{item.USUARIO}</td>
                                                               
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                              
                                            </table>
                                        </div>
                                    </div>
                                </div>
                          
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="ModalActualizacion" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="ModalActualizacionLabel" aria-hidden="true">
                    <div className="modal-dialog modal-sm" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="ModalActualizacionLabel"> ACTUALIZACION MASIVA DE UTILIDAD</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card">
                                 
                                    <div className="card-body">
                                        <div className='row'>
                                        <div className="col-md-12">
                                                    <label htmlFor="categoria">Categoria</label>
                                                    <select name="categoria"
                                                        id="categoria"
                                                        className={"form-select form-select-sm"} >
                                                        <option value="">Seleccione la categoria</option>
                                                        <option value="1">LUMINARIA</option>
                                                        <option value="2">CABLE</option>
                                                        <option value="3">POSTES</option>
                                                        <option value="4">HERAJERIA + ALL</option>
                                                        <option value="5">TRANSFORMADOR</option>
                                                        <option value="6">MANO DE OBRA</option>
                                                        <option value="7">TRANSPORTE</option>
                                                        <option value="8">EQUIPO</option>
                                                    </select>
                                                
                                                </div>
                                                <div className="col-md-12">
                                                    <label htmlFor="categoria">Porcentaje</label>
                                                    <input type="number" name='porcentaje' id='porcentaje' className='form-control' ></input>
                                                  
                                                </div>
                                                <div className="col-md-12">
                                                   <br></br>
                                                    {Btn==0?
                                                    <button type='button' id='btnpor' className='btn btn-primary' onClick={()=>this.porcentaje()}>Actualizar</button>:
                                                    <button type='button' id='btnpor' className='btn btn-primary' disabled>Cargando...</button>}
                                                    <button type='button' className='btn btn-danger'  data-bs-dismiss="modal" aria-label="Close">Cancelar</button>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                          
                            </div>
                        </div>
                    </div>
                </div>

                

            </div>
        );
    }
}

export default Listar;